import React from 'react';
import './Hero.css';
import logo from '../assets/images/logo_Golden_without_background.png';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-logo">
          <img src={logo} alt="Jasar Institute Logo" className="hero-logo-img" />
          <h2 className="hero-logo-text">
            <span className="hero-logo-text-inner">Jasar Institute</span>
          </h2>
        </div>
        <h1 className="hero-title">
          Your Bridge to <span className="highlight">Learning and Wisdom</span>
        </h1>
        <p className="hero-subtitle">
          Authentic Islamic education through fast, easy, and modern methods
        </p>
        <div className="hero-buttons">
          <a href="#about" className="btn btn-primary">Learn More</a>
          <a href="#mission" className="btn btn-secondary">Our Mission</a>
        </div>
      </div>
      <div className="hero-scroll">
        <div className="scroll-indicator"></div>
      </div>
    </section>
  );
};

export default Hero;
